import styled from 'styled-components';

import { spaceXXL } from '@xing-com/tokens';

export const ShowMoreWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: ${spaceXXL};
`;
